import { RouteObject, Navigate } from 'react-router-dom';
import { UsersRoutes } from './modules/users/routes';
import { RolesRoutes } from './modules/roles/routes';
import { SuitesRoutes } from './modules/suites-modules/routes';
import { BrandingRoutes } from './modules/branding/routes';
import { CustomFieldsRoutes } from './modules/custom-fields/routes';
import { AutomationsRoutes } from './modules/automations/routes';
import { ApiKeysRoutes } from './modules/api-keys/routes';
import { AuditLogRoutes } from './modules/audit-log/routes';
import { StaffActivityRoutes } from './modules/staff-activity/routes';

export const settingsRoutes: RouteObject[] = [
  {
    path: '',
    element: <Navigate to="suites" replace />,
  },
  SuitesRoutes,
  UsersRoutes,
  RolesRoutes,
  BrandingRoutes,
  CustomFieldsRoutes,
  AutomationsRoutes,
  ApiKeysRoutes,
  AuditLogRoutes,
  StaffActivityRoutes,
  // Backward compatibility alias redirects
  { path: 'suites-modules', element: <Navigate to="/settings/suites" replace /> },
  { path: 'api', element: <Navigate to="/settings/api-keys" replace /> },
  { path: 'audit', element: <Navigate to="/settings/audit-log" replace /> },
];

export default settingsRoutes;
